import React, { useContext } from 'react';

import SuccessModal from 'apps/web_forms/components/commons/SuccessModal';
import NotificationBar from 'apps/web_forms/components/NotificationBar';
import { NotificationBarContext } from 'apps/web_forms/contexts/NotificationBarContext';

const AppRootComponents = () => {
  const {
    showNotificationBar,
    notificationBarText,
    notificationBarType,
    buttons,
    rightContents,
    alignLeft,
  } = useContext(NotificationBarContext);

  return (
    <>
      <SuccessModal />
      <NotificationBar
        isShown={showNotificationBar}
        notificationText={notificationBarText}
        type={notificationBarType}
        buttons={buttons}
        rightContents={rightContents}
        alignLeft={alignLeft}
      />
    </>
  );
};

export default AppRootComponents;
